export default __webpack_public_path__ + "static/media/car-diesel.7401b6ea.svg";